// Import dependencies
import React, {Component} from 'react';

// Import components
import { ParagraphText } from "../../components/global/UXLibrary";

// Import css
import './RotateScreen.css';


export default class RotateScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orientation: true
        }
    }


    componentWillMount() {
        if ('onorientationchange' in window) {
            window.addEventListener("orientationchange", function() {
                this.setState({ orientation: !this.state.orientation })
            }.bind(this), false);
        }
    }


    render() {
        return (
            <div>
                {
                    this.state.orientation ?
                        <div className='rs__container'>
                            <div className="rs__phone" />
                            <ParagraphText className="rs__message">
                                Please rotate your device!
                            </ParagraphText>
                        </div>
                        :
                        null
                }
            </div>
        );
    }
}
